//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  ArrowBackIcon,
  CheckCircleIcon,
  ChevronLeftIcon,
} from "@chakra-ui/icons";
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Collapse,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  HStack,
  Icon,
  Img,
  Select,
  Stack,
  Text,
  useBreakpointValue,
  useDisclosure,
  useRadio,
  useRadioGroup,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import React from "react";
import { object, string } from "yup";
import ExpandingTextArea, {
  EnhancedTextarea,
} from "../../components/form-elements/ExpandingTextArea";
import {
  parseStringForTriggers,
  useStreamingProfileDescription,
} from "../../components/form-elements/ExpandingTextArea/hook";
import { SingleFormButton } from "./FormButtons";
import { DisplayCheckErrors } from "./DisplayCheckErrors";
import isEmpty from "lodash.isempty";
import { TittleSuggestions, useTitleSuggestion } from "./SubjectTitleForm";
import { HiOutlineRefresh } from "react-icons/hi";
import { generateFormComponent } from "../TeachingPreference";
import { IUploadStore } from "../../stores";
import { useLocalStorage } from "../../tutor-application/utils";

function RadioCard(props) {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input: any = getInputProps();
  const checkbox: any = getCheckboxProps();

  return (
    <Box as="label">
      <input {...input} />
      <HStack
        {...checkbox}
        justify="space-between"
        bg="neutral.200"
        cursor="pointer"
        borderWidth="2xs"
        rounded="lg"
        borderColor="neutral.300"
        p={[5, 6]}
      >
        <Box mr={6}>{props.children}</Box>

        {props.isChecked && <CheckCircleIcon fontSize="xl" color="blue.600" />}
      </HStack>
    </Box>
  );
}

function DescriptionStartOption({ onChange, value }) {
  const options = [
    { label: "Use a previous description", value: "1" },
    { label: "Create a fresh description", value: "2" },
  ];

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "framework",
    defaultValue: value,
    onChange,
  });

  const group: any = getRootProps();

  return (
    <Stack {...group}>
      {options.map((option) => {
        //@ts-ignore
        const radio = getRadioProps({ value: option.value });
        return (
          <RadioCard key={option.value} {...radio}>
            {option.label}
          </RadioCard>
        );
      })}
    </Stack>
  );
}

const initialValue = {
  description: "",
  teachingStyle: "",
  trackRecords: "",
  title: "",
  preferences: {},
};

const errorMessages = {
  description: "Oops! Too long. Try to keep it under 300 characters",
  teachingStyle: "Too long. Try make it 250 characters",
  trackrecord: "Too long. Try make it 250 characters",
};

const placeholders = {
  title: {
    placeholder: "E.g. Ph.D. in Mathematics, Cambridge Certified Math Tutor",
    characterLimit: 75,
  },
  description: {
    placeholder:
      "I have a First-Class degree (B.Sc.) in Mathematics, M.Sc. and Ph.D. in Mathematical Physics. I've taught Cambridge / A-Level, SAT, 11+, IB Math, Ed Excel, Further Math and Physics for over 12 years with nearly 100% success rate preparing my students for Math exams. I'm a Cambridge Certified Tutor, and a WAEC/NECO Examiner. I also had As in all my Math courses. I make Math easy and enjoyable.",
    characterLimit: 400,
  },
};

function getMaxLength(name) {
  return placeholders[name].characterLimit;
}

const validationSchema = object().shape({
  title: string()
    .transform((value) => value.replace(/ +/g, " "))
    .trim()
    .max(75, "Oops! Seems this headline is too long")
    .min(10, "Must be a minimum of 10 characters")
    .required("Give your subject a headline"),
  description: string()
    .transform((value) => value.replace(/ +/g, " "))
    .trim()
    .max(getMaxLength("description"), errorMessages["description"])
    .min(250, "Must be 300 characters at least")
    .required("Describe your expertise"),
});

const commonProps = ({ name }, { touched, errors }) => ({
  ...placeholders[name],
  isInvalid: Boolean(touched[name] && errors[name]),
  errorMessage: errors[name],
});

export const hasNoTriggerWords = (inputValues, triggers = {}) => {
  return Object.values(inputValues).every(
    (input: any) => !Boolean(parseStringForTriggers(input, triggers))
  );
};

const SubjectDescriptionForm: React.FC<{
  value?: {
    description: string;
    trackRecords: string;
    teachingStyle: string;
    title?: string;
  };
  onSubmit?: (params: {}) => Promise<any>;
  loading: boolean;
  onBackClick?: () => void;
  availableSubjects?: any;
  subject?: string;
  saveOnBlur: (name, value) => void;
  titleSubject: {
    name: string;
    subcategory: string;
    category: string;
  };
  preferenceFields: any;
  uploadStore: IUploadStore;
  TUTORDATA: {
    education: Array<{
      school?: string;
      country?: string;
      specialty?: string;
      course?: string;
      grade?: string;
      degree?: string;
      startYear?: string;
      endYear?: string;
    }>;
    workHistory: Array<{
      company?: string;
      role?: string;
      isTeachingRole?: boolean;
      startYear?: string;
      endYear?: string;
      isCurrent?: boolean;
      showOnProfile?: boolean;
    }>;
  };
  getDescriptionSummary?: () => Generator<Promise<any>, string, any>;
}> = ({
  value,
  onSubmit,
  subject,
  availableSubjects = [],
  titleSubject,
  loading,
  onBackClick,
  saveOnBlur,
  preferenceFields,
  TUTORDATA,
  uploadStore,
  getDescriptionSummary,
}) => {
  const streamingCall = useStreamingProfileDescription(getDescriptionSummary);
  const title_local_storage = useLocalStorage("title", "");
  const description_local_storage = useLocalStorage("description", "");
  const [showFormError, setShowFormError] = React.useState(false);
  const [suggestions, setSuggestions] = React.useState<any>({});
  const { getSugestions, formatInput } = useTitleSuggestion(
    TUTORDATA,
    titleSubject
  );
  React.useEffect(() => {
    setSuggestions(getSugestions());
  }, []);

  const handleRefreshTitles = () => {
    setSuggestions(getSugestions());
  };

  const [showSuggestions, setShowSuggestions] = React.useState(false);
  const sampleDescription = useDisclosure();

  const [descriptionOption, setDescriptionOption] = React.useState("");
  const [errorObj, setErrorObjects] = React.useState({});
  const _handleSubmit = async (values, formikHelpers) => {
    formikHelpers.setSubmitting(true);
    try {
      let res = await onSubmit(values);
      formikHelpers.setSubmitting(false);
      title_local_storage.removeValue();
      description_local_storage.removeValue();
      return res;
    } catch (error) {
      formikHelpers.setSubmitting(false);
      if (error?.spellCheck) {
        formikHelpers.setErrors(error.spellCheck);
        if (error?.errors) {
          setErrorObjects(error.errors);
        }
      }
    }
  };

  const textAreaRows = useBreakpointValue({ base: 11, md: 7 });
  const defaultValues = {
    ...initialValue,
    ...value,
  };
  defaultValues.title = title_local_storage.value || defaultValues.title;
  defaultValues.description =
    description_local_storage.value || defaultValues.description;
  return (
    <Box as="section">
      <Button
        ml={-1}
        mb={{ base: 8, md: 10 }}
        size={useBreakpointValue({ base: "sm", md: "md" })}
        iconSpacing={1}
        colorScheme="blue"
        leftIcon={<ChevronLeftIcon fontSize={{ base: "xl", md: "2xl" }} />}
        variant="link"
        onClick={onBackClick}
      >
        Back
      </Button>
      <Formik
        validationSchema={validationSchema}
        initialValues={defaultValues}
        enableReinitialize
        onSubmit={(values, formikAction) =>
          hasNoTriggerWords({
            title: values.title,
            description: value?.description || "",
          }) && _handleSubmit(values, formikAction)
        }
        render={({ handleSubmit, values, setValues }) => {
          return (
            <Stack
              spacing={6}
              id="form-header-section"
              className="subject-description-form"
            >
              <Stack spacing={4} mb={6}>
                <Text
                  fontWeight="bold"
                  lineHeight="shorter"
                  fontSize={["3xl", "4xl"]}
                >
                  Your {subject} subject
                </Text>
                <Text color="gray.700">
                  To get more bookings, create a compelling subject to convince
                  them that you are the best in this subject. Clients read this
                  when deciding who to hire.
                </Text>
              </Stack>
              <form onSubmit={handleSubmit}>
                {(values.description ||
                  availableSubjects.length === 0 ||
                  descriptionOption === "2") && (
                  <Stack pb={12} spacing={{ base: 8, md: 10 }}>
                    <Stack>
                      <Box pb={3}>
                        <Text fontSize="2xl" fontWeight="bold" as="h1">
                          Add a short title
                        </Text>
                        <Text mt={1} color="gray.600">
                          Create a strong title to highlight your unique
                          expertise in teaching {subject}.
                        </Text>
                      </Box>
                      <Field
                        name="title"
                        render={({ field, form }) => {
                          return (
                            <Stack spacing={4}>
                              {suggestions?.displayed && (
                                <HStack justify="space-between" width="100%">
                                  <Button
                                    variant="link"
                                    type="button"
                                    colorScheme="blue"
                                    onClick={() =>
                                      setShowSuggestions(!showSuggestions)
                                    }
                                  >
                                    See helpful examples
                                  </Button>

                                  {showSuggestions && (
                                    <Icon
                                      cursor="pointer"
                                      as={HiOutlineRefresh}
                                      color="blue.500"
                                      fontSize="xl"
                                      onClick={handleRefreshTitles}
                                    />
                                  )}
                                </HStack>
                              )}

                              <Collapse in={showSuggestions}>
                                <TittleSuggestions
                                  suggestions={suggestions?.displayed}
                                  onChange={(value) => {
                                    form.setFieldValue(field.name, value);
                                  }}
                                />
                              </Collapse>
                              <FormControl
                                isInvalid={commonProps(field, form).isInvalid}
                              >
                                <EnhancedTextarea
                                  padding="16px"
                                  rounded="md"
                                  resize="none"
                                  fontSize={{ base: "lg", md: "xl" }}
                                  minHeight={{ base: "116px", md: "96px" }}
                                  borderColor="neutral.500"
                                  fontWeight={field.value ? "medium" : "normal"}
                                  _focus={{
                                    borderColor: "blue.500",
                                    boxShadow: "0 0 0 1px blue",
                                  }}
                                  {...field}
                                  {...commonProps(field, form)}
                                  characterCount={field.value.length}
                                  onChange={(value) => {
                                    const ve = formatInput(value);
                                    form.setFieldValue(field.name, ve);
                                    title_local_storage.setValue(ve);
                                  }}
                                />
                                <FormErrorMessage>
                                  {commonProps(field, form).errorMessage}
                                </FormErrorMessage>

                                {!isEmpty(errorObj) && (
                                  <DisplayCheckErrors
                                    name={field.name}
                                    errors={errorObj}
                                    subject={titleSubject.name}
                                  />
                                )}
                              </FormControl>
                            </Stack>
                          );
                        }}
                      />
                    </Stack>

                    <Stack>
                      <Box pb={3}>
                        <Text
                          fontSize="2xl"
                          lineHeight="shorter"
                          fontWeight="bold"
                          as="h1"
                        >
                          Longer description
                        </Text>
                        <Text mt={1} color="gray.600">
                          Summarize of your qualifications, expertise and track
                          record. Invite clients to hire you for this subject.
                          Let them know the kind of tutoring and results you can
                          offer.
                        </Text>
                      </Box>
                      <Field
                        name="description"
                        render={({ field, form }) => (
                          <Stack spacing={4}>
                            <HStack justifyContent={"space-between"}>
                              <Button
                                variant="link"
                                type="button"
                                colorScheme="blue"
                                onClick={() => sampleDescription.onToggle()}
                              >
                                See some good examples
                              </Button>
                             {Boolean(getDescriptionSummary) && <Button
                                type="button"
                                colorScheme="blue"
                                isLoading={streamingCall.loading}
                                onClick={() => {
                                  streamingCall.generateDescription();
                                }}
                              >
                                Generate Description
                              </Button>}
                            </HStack>

                            <Collapse in={sampleDescription.isOpen}>
                              <Stack spacing={4}>
                                <Stack>
                                  <Text fontWeight="medium">Example 1</Text>
                                  <Box rounded="lg" overflow="hidden">
                                    <Img
                                      boxSize="full"
                                      objectFit="cover"
                                      src="https://res.cloudinary.com/tuteria/image/upload/v1675475601/landingpage/Subject2.png"
                                    />
                                  </Box>
                                </Stack>
                                <Stack>
                                  <Text fontWeight="medium">Example 2</Text>
                                  <Box rounded="lg" overflow="hidden">
                                    <Img
                                      boxSize="full"
                                      objectFit="cover"
                                      src="https://res.cloudinary.com/tuteria/image/upload/v1675475601/landingpage/Subject1.png"
                                    />
                                  </Box>
                                </Stack>
                                <Stack>
                                  <Text fontWeight="medium">Example 3</Text>
                                  <Box rounded="lg" overflow="hidden">
                                    <Img
                                      boxSize="full"
                                      objectFit="cover"
                                      src="https://res.cloudinary.com/tuteria/image/upload/v1675475601/landingpage/Subject3.png"
                                    />
                                  </Box>
                                </Stack>
                              </Stack>
                            </Collapse>

                            <FormControl
                              isInvalid={commonProps(field, form).isInvalid}
                            >
                              <ExpandingTextArea
                                {...field}
                                {...commonProps(field, form)}
                                rows={textAreaRows}
                                name={field.name}
                                streamingText={streamingCall.text}
                                streamingLoading={streamingCall.loading}
                                onChange={(value) => {
                                  form.setFieldValue(field.name, value);
                                  description_local_storage.setValue(value);
                                }}
                                onBlur={(e) =>
                                  saveOnBlur(e.target.name, field.value)
                                }
                              />
                              <FormErrorMessage>
                                {commonProps(field, form).errorMessage}
                              </FormErrorMessage>

                              {!isEmpty(errorObj) && (
                                <DisplayCheckErrors
                                  name={field.name}
                                  errors={errorObj}
                                  subject={titleSubject.name}
                                />
                              )}
                            </FormControl>
                          </Stack>
                        )}
                      />
                    </Stack>

                    {/* {preferenceFields?.length > 0 && (
                          <Stack id="form-header-section">
                            <Box pb={3}>
                              <Text
                                fontSize="2xl"
                                lineHeight="shorter"
                                fontWeight="bold"
                                as="h1"
                              >
                                Add preferences
                              </Text>
                              <Text mt={1} color="gray.600">
                                Select the options that best captures your tutoring
                                preferences and background
                              </Text>
                              {showFormError && (
                                <Box pt={2}>
                                  <Alert rounded="lg" status="error">
                                    <AlertIcon />
                                    Error submitting forms, some fields are required
                                  </Alert>
                                </Box>
                              )}
                            </Box>

                            <Stack spacing={8}>
                              {preferenceFields.map((fieldItem, index) => {
                                return (
                                  <Box key={index}>
                                    <Field
                                      name={`preferences.${fieldItem.name}`}
                                      render={({ field, form }) => {
                                        let display = true;
                                        const FormComponent =
                                          generateFormComponent(fieldItem);
                                        let props: any = {
                                          formField: fieldItem,
                                          value: field.value,
                                          field: field,
                                          form: form,
                                          uploadStore: uploadStore,
                                        };
                                        let rendered = display ? (
                                          <FormComponent
                                            onChange={(value) => {
                                              form.setFieldValue(field.name, value);
                                              // updatePreferences(field.name, value);
                                            }}
                                            value={field.value}
                                            // showVerification={showVerification}
                                            {...props}
                                          />
                                        ) : null;
                                        return (
                                          <Box className="render-component">
                                            {rendered}
                                          </Box>
                                        );
                                      }}
                                    />
                                  </Box>
                                );
                              })}
                            </Stack>
                          </Stack>
                        )} */}
                  </Stack>
                )}

                <SingleFormButton
                  nextText="Save my subject"
                  isLoading={loading}
                  onNextClick={handleSubmit}
                />
              </form>
            </Stack>
          );
        }}
      />
    </Box>
  );
};

export default SubjectDescriptionForm;
